"use client";

import React from 'react';
import { LogOut, FolderTree, Settings } from 'lucide-react';
import { signOut } from "next-auth/react";
import Link from 'next/link';
import { ThemeToggle } from './ThemeToggle';

interface HeaderProps {
    userName?: string | null;
    onOpenSettings: () => void;
}

export const StudioHeader: React.FC<HeaderProps> = ({ userName, onOpenSettings }) => {
    return (
        <header className="flex justify-end items-center mb-6 border-b border-zinc-200 dark:border-zinc-900/50 pb-4 px-6 pt-2 transition-colors">

            <div className="flex items-center gap-6">
                <button onClick={onOpenSettings} className="p-2 rounded-lg hover:bg-zinc-200 dark:hover:bg-zinc-800 text-zinc-500 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-white transition-all">
                    <Settings size={18} />
                </button>
                <ThemeToggle />

                <Link
                    href="/filemanager"
                    className="flex items-center gap-2 px-3 py-2 bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 rounded-none text-zinc-600 dark:text-zinc-400 hover:text-blue-600 dark:hover:text-white hover:bg-zinc-50 dark:hover:bg-zinc-800 transition-all group"
                >
                    <FolderTree size={16} className="text-zinc-400 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors" />
                    <span className="text-xs font-bold uppercase tracking-wider">文件管理</span>
                </Link>

                {userName && (
                    <div className="flex items-center gap-4 border-l border-zinc-200 dark:border-zinc-800 pl-6 text-right">
                        <div className="flex flex-col items-end">
                            <span className="text-[10px] text-zinc-400 dark:text-zinc-500 font-bold uppercase tracking-wider">会话处于活动状态</span>
                            <span className="text-sm text-zinc-700 dark:text-zinc-200 font-medium">{userName}</span>
                        </div>
                        <button
                            onClick={() => signOut()}
                            className="p-2.5 bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 rounded-none text-zinc-400 dark:text-zinc-500 hover:text-red-600 dark:hover:text-red-400 hover:bg-red-50 dark:hover:bg-red-500/5 hover:border-red-200 dark:hover:border-red-500/20 transition-all"
                            title="退出登录"
                        >
                            <LogOut size={16} />
                        </button>
                    </div>
                )}
            </div>
        </header>
    );
};
